<template>
  <div
    class="overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px] animate-pulse"
  >
    <div
      class="hidden md:grid grid-cols-12 gap-1 w-full items-center px-4 py-2"
      style="background: var(--Neutral-LightGray-5, #fafafa)"
    >
      <div class="col-span-3">
        <div class="h-4 w-14 bg-slate-200 rounded"></div>
      </div>
      <div class="col-span-3">
        <div class="h-4 w-14 bg-slate-200 rounded"></div>
      </div>
      <div class="col-span-2">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="col-span-3">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="col-span-1 flex justify-end">
        <div class="h-4 w-12 bg-slate-200 rounded"></div>
      </div>
    </div>

    <div
      v-for="n in 5"
      :key="n"
      class="grid grid-cols-12 gap-1 w-full items-center px-4 py-4 border-b border-gray-100"
    >
      <div class="hidden md:block md:col-span-3">
        <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden md:block md:col-span-3">
        <div class="h-4 w-11/12 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden md:block md:col-span-2">
        <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden md:block md:col-span-3">
        <div class="flex gap-2">
          <div class="h-6 w-20 bg-slate-200 rounded-full"></div>
          <div class="h-6 w-14 bg-slate-200 rounded-full"></div>
          <div class="h-6 w-10 bg-slate-200 rounded-full"></div>
        </div>
      </div>

      <div class="hidden md:flex md:col-span-1 justify-end gap-2">
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
        <div class="h-5 w-5 bg-slate-200 rounded"></div>
      </div>

      <div class="flex flex-col gap-3 md:hidden col-span-12 px-1">
        <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
        <div class="h-3 w-11/12 bg-slate-200 rounded"></div>
        <div class="h-3 w-1/2 bg-slate-200 rounded"></div>
        <div class="flex gap-2 pt-1">
          <div class="h-6 w-16 bg-slate-200 rounded-full"></div>
          <div class="h-6 w-12 bg-slate-200 rounded-full"></div>
        </div>
        <div class="flex gap-2 pt-1">
          <div class="h-5 w-5 bg-slate-200 rounded"></div>
          <div class="h-5 w-5 bg-slate-200 rounded"></div>
          <div class="h-5 w-5 bg-slate-200 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
